/**
 * Select Component
 * --------------------------------------------------------------------
 * @summary select, uses Choices
 *
 * See https://github.com/Choices-js/Choices for more select options
 *
 * @usage
 *
 *     {%- capture select_options -%}
 *       {
 *         "searchEnabled": true,
 *         "shouldSort": true,
 *         ...
 *       }
 *     {%- endcapture -%}
 *      <s-select data-options='{{ select_options | escape }}'>
 *        <select>
 *          <option></option>
 *        </select>
 *      </s-select>
 *
 * The following parameters are attributes that the <s-select> element takes
 * @param data-options - object containing select options
 *                       ex.{"searchEnabled": true, "shouldSort": true}
 *                       only needed if modifying or extending on default options
 *                       be careful with syntax here you have to use single quote on the outside,
 *                       and double quotes in the capture so that the JSON.parse() doesn't error.
 *                       DEFAULT OPTIONS:
 *                          searchEnabled: false,
 *                          shouldSort: false,
 *                          allowHTML: true,
 *                          itemSelectText: ''
 *                          on: {ready: this._onReady},
 *
 */

export class Select extends HTMLElement {
    constructor() {
        super();

        this._selectors = {
            selectDropdown: "select",
        };

        this.options = {
            searchEnabled: false,
            shouldSort: false,
            allowHTML: true,
            itemSelectText: "",
        };
    }

    connectedCallback() {
        const extendedOptions = this.dataset.options
            ? JSON.parse(this.dataset.options)
            : {};
        this.options = Object.assign(this.options, extendedOptions);
        this._initFakeDropdown();
    }

    _initFakeDropdown() {
        // use Choices.js for custom select dropdowns
        // https://github.com/Choices-js/Choices
        const selectDropdown = this.querySelector(
            this._selectors.selectDropdown,
        );
        const choices = new Choices(selectDropdown, this.options);
        this.choices = choices;
    }
}
